module.exports = __webpack_public_path__ + "img/message-system.61c6ef46.png";